<template>
  <div class="iconRow-item">
    <img class="iconRow-item-icon" :src="item.imgUrl" :alt="item.name" />
    <div class="iconRow-item-name">{{ item.name }}</div>
    <BottomLine />
    <div class="iconRow-item-desc">{{ item.intro }}
    </div>
  </div>
</template>

<script>
import BottomLine from '@/components/BottomLine.vue';

export default {
  name: 'IconRowItem',
  components: {
    BottomLine,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({ imgUrl: '', name: '', intro: '' }),
    },
  },
};
</script>

<style lang="less" scoped>
.iconRow-item {
  cursor: pointer;
  width: 226px;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  color: #001F34;

  .iconRow-item-icon {
    width: 80px;
    height: 80px;
  }

  .iconRow-item-name {
    font-size: 16px;
    font-weight: 900;
  }

  .iconRow-item-desc {
    margin: 0 auto;
    width: 226px;
    font-size: 14px;
    font-weight: normal;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
}

.iconRow-item:hover {
  .iconRow-item-desc {
    opacity: 1;
  }
}
</style> 